import React from 'react';
import style from './style.module.scss';

const NasdaqLogo: React.FC<{ height?: number | string; className?: string }> = ({ height = 32, className }) => (
  <img
    src='/img/nasdaq-logo.svg'
    alt='Nasdaq Logo'
    className={`${style['logo-img']} ${className || ''}`.trim()}
    style={height ? { height } : undefined}
    data-testid='nasdaq-logo'
  />
);

export default NasdaqLogo;
